import BitIconSpinner from '../../../../../ui/Spinner/Spinner';
import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import { FetchOfferBar } from './FetchOfferBar';

interface FetchLoadingProps {
  message: string;
  isMobile?: boolean;
}

export function FetchLoading({ message, isMobile }: FetchLoadingProps) {
  const theme = useTheme();
  const rootClass = isMobile
    ? `${styles.petScreen} ${styles.mobile}`
    : styles.petScreen;

  return (
    <div
      className={rootClass}
      style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}
    >
      {!isMobile && <FetchOfferBar />}
      <div className={styles.loadingBody}>
        <BitIconSpinner s={{ width: 40, height: 40 }} />
        <p className={styles.loadingText}>{message}</p>
      </div>
    </div>
  );
}
